export default __webpack_public_path__ + "static/media/youtube.450c8a51.svg";